
import weirwood from './weirwood';
import {Component, ReactNode} from 'react';
import {perfLogger} from './buried/performance';
import * as store from '@/store';
import {getKnowledgePageRouteMatchInfo} from './utils/urlUtils';
interface ErrorBoundaryProps {
    children?: ReactNode;
}


export default class WeirwoodErrorBoundary extends Component<ErrorBoundaryProps> {

    /*
     * 死循环注意！！！！！
     * 如不加错误挡板页面 不能使用getDerivedStateFromError
     * 在React版本v17.0.1中使用时
     * 一旦页面错误就会触发WeirwoodErrorBoundary的渲染
     * 哪怕并没有state、props变更
     * 如错误是组件一渲染就会被触发 那么会引起页面反复渲染
    */
    // static getDerivedStateFromError() {
    //     return {hasError: true};
    // }

    componentDidCatch(error: Error | string) {
        const captureError = perfLogger.captureError;
        const {isDocPage} = getKnowledgePageRouteMatchInfo();
        const docMode = store.getDocumentMode();
        if (typeof error === 'string' || !error) {
            error = new Error(error);
        }
        error.message = `wiki render crash ${error.message}`;
        if (isDocPage) {
            error.message = `${error.message} docMode: ${docMode}`;
        }
        weirwood && weirwood.error.captureException(error);
        // 未被try catch住的error
        captureError.captureError(error, captureError.ERROR_TYPE.unCapturedError);
    }

    render() {
        return this.props.children;
    }
}
